import { useToast } from "@/ds";
import { exportEmbarcacaoDetalhe } from "@/modules/embarcacoes";
import { createExportFeedback, useFileExport, XLSX_LAYOUT_DETAILS } from "@/modules/export";
import type { ExportFormat, FileExportOptions } from "@/modules/export";
import { HUB_PERMISSOES, usePermissoes } from "@/modules/permissoes";
import type { EmbarcacaoDetailIdentity } from "../components/embarcacao-detail-dialog/types-embarcacao-detail-dialog";

interface UseEmbarcacaoDetalheExportacaoParams {
  readonly embarcacaoId: string;
  readonly identity: EmbarcacaoDetailIdentity;
}

/**
 * Exportar o detalhamento (HU 2388): PDF, Excel e CSV vêm do serviço. O botão só aparece
 * com `hub.embarcacao:export` (oculto enquanto as permissões carregam ou se falharem); se o serviço ainda assim
 * devolver 403, é exibido como "Acesso não autorizado".
 */
export function useEmbarcacaoDetalheExportacao({
  embarcacaoId,
  identity,
}: UseEmbarcacaoDetalheExportacaoParams) {
  const toast = useToast();
  const { hasPermissao } = usePermissoes();
  const fileExport = useFileExport({
    fileName: `embarcacao-detalhamento-${identity.acronimo.trim() || embarcacaoId}`,
    loadFile: (format, options) =>
      exportEmbarcacaoDetalhe(embarcacaoId, format, { xlsxLayout: options?.xlsxLayout }),
    ...createExportFeedback(toast),
  });

  return {
    podeExportar: hasPermissao(HUB_PERMISSOES.EMBARCACOES_EXPORTACAO),
    abrirExportacao: fileExport.open,
    exportando: fileExport.isExporting,
    exportDialog: {
      isOpen: fileExport.isOpen,
      isExporting: fileExport.isExporting,
      xlsxLayouts: XLSX_LAYOUT_DETAILS,
      exportar: (format: ExportFormat, options?: FileExportOptions) => {
        void fileExport.run(format, options);
      },
      fechar: fileExport.close,
    },
  };
}
